import React from 'react'

const ToolbarClassic = () => {
  // Karena tombol tema sudah dipindahkan ke HeaderWrapper,
  // komponen toolbar ini sekarang kosong.
  return null
}

export {ToolbarClassic}